import { lettersToNumber } from './pythagorean.js';
import { reduceToDigit } from './reduce.js';
/**
 * Expression (name) number — Pythagorean mapping of every letter in the
 * full name, summed and reduced. Works with mixed Russian / English chars.
 */
export function calcExpressionNumber(fullName) {
    return reduceToDigit(lettersToNumber(fullName));
}
//# sourceMappingURL=expression.js.map